import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NSession } from './df-session.config';

export function provideDfSession(config?: DeepPartial<NSession.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: NSession.OPTIONS,
            useFactory: () => defaultsDeep(config, NSession.DEFAULT_OPTIONS)
        }
    ]);
}
